var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "cms-pdf-viewer-block" }, [
    _vm.resolvedSrc
      ? _c("iframe", {
          staticClass: "cms-pdf-viewer-block__frame",
          style: _vm.frameStyle,
          attrs: {
            src: _vm.resolvedSrc,
            frameborder: "0",
            allowfullscreen: "",
            title: _vm.title || "PDF Viewer",
          },
        })
      : _c("div", { staticClass: "cms-pdf-viewer-block__empty" }, [
          _c("i", { staticClass: "fa fa-file-pdf-o" }),
          _vm._v(" "),
          !_vm.src
            ? _c("span", [_vm._v("No PDF URL configured.")])
            : _c("span", [
                _vm._v("PDF URL must start with http:// or https://"),
              ]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }